import { render, staticRenderFns } from "./Ordem.vue?vue&type=template&id=6ba81626&scoped=true&"
import script from "./Ordem.vue?vue&type=script&lang=js&"
export * from "./Ordem.vue?vue&type=script&lang=js&"
import style0 from "./Ordem.vue?vue&type=style&index=0&id=6ba81626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba81626",
  null
  
)

export default component.exports